<obp-timeline [Items]="items" [Groups]="groups" [(SelectedGroup)]="SelectedGroup" [verticalScroll]="true">
    <a [obp-timeline-group]="GetGroupForWaterway(ww)" OBPTimelineGroupTarget="timeline" *ngFor="let ww of Waterways" class='go-to-detail' routerLink="/waterway/{{ww.Id}}" routerLinkActive="active">
        <svg><use href="assets/icons.svg#icn-arrow_next" /></svg>
    </a>
</obp-timeline>
